import { languages } from "../actions/types"

const defaultLanguagesData = {
	data: [],
	redirectUrl: null,
	isLoading: true,
	hasError: false,
	error: null,
	isShowing: false,
	isLoadingActions: false,
	isSavingPermissions: false,
	isRedirecting: false,
	isExporting: false,
	isDeleting: false,
	isRestoring:false,
	isValidating:false,
	filters: [],
	meta: {
		pagination: {
			total: 0,
			count: 0,
			per_page: 15,
			current_page: 1,
			total_pages: 1,
		}
	}
}

const languagesReducer = (state = defaultLanguagesData, action = []) => {
	switch (action.type) {

		case languages.GET_LANGUAGES_STARTED:
			return { ...state, isLoading: true }

		case languages.GET_LANGUAGES_SUCCESS:
			if (action.payload)
				return { ...state, ...action.payload, isLoading: false }
			return state

		case languages.GET_LANGUAGES_ERROR:
			return { ...state, isLoading: false, hasError: true }

		case languages.SHOW_LANGUAGES_STARTED:
			return { ...state, isShowing: true }

		case languages.SHOW_LANGUAGES_SUCCESS:
			if (!action.payload.id)
				return state
			if (state.data.find(item => (item.id === action.payload.id)))
				return { ...state, isShowing: false, data: state.data.map(item => (item.id === action.payload.id ? action.payload : item)) }
			return { ...state, data: [...state.data, action.payload], isShowing: false }

		case languages.SHOW_LANGUAGES_ERROR:
			return { ...state, isShowing: false, hasError: true }

		case languages.CREATE_LANGUAGES_STARTED:
			return { ...state, isSaving: true }

		case languages.CREATE_LANGUAGES_SUCCESS:
			if (action.payload)
				return {
					...state,
					data: [...state.data, { ...action.payload.data }],
					isSaving: false
				}
			return state

		case languages.CREATE_LANGUAGES_ERROR:
			return { ...state, isSaving: false, hasError: true }

		case languages.DELETE_LANGUAGES_STARTED:
			return {...state, isDeleting:true}

		case languages.DELETE_LANGUAGES_SUCCESS:
			if (action.payload)
				return {...state, data: state.data.filter(item => (item.id !== action.payload.id)), isDeleting: false}
			return state

		case languages.DELETE_LANGUAGES_ERROR:
			return { ...state, isDeleting:false, hasError:true }
		default:
			return state
	}
}


export default languagesReducer
